<template>
    <div class="has-background-heat-blue-1 has-text-white">
        <div v-if="edar" class="hero" style="padding-top: 0.5em;">
            <div class="hero-head has-text-centered">
                <h1 class="title is-1 has-text-white">Live View: {{edar.name}}</h1>
            </div>
            <div class="hero-body" style="padding-bottom: 0">
                <viewer :edar="edar"></viewer>
            </div>
        </div>
    </div>
</template>

<script>
    import Viewer from "../components/Viewer";
    export default {
        name: "LiveView",
        components: {Viewer},
        props: {
            edarId: {
                type: [String, Number],
                required: true,
            },
        },
        computed: {
            //Pull the specific EDAR we're interested in out of the store
            edar: function () {
                return this.$store.getters['edar/byId'](this.edarId);
            },
        },
    }
</script>

<style scoped>

</style>